module.exports = __webpack_public_path__ + "media/images/illustrations/404-error-9a2586eb94a1f9c0555ea95b35c40ece.svg";